import CountUp from 'react-countup';
import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useEffect } from 'react';

const Statistics = () => {
	const { $t } = useIntl();
	const statisticsData = [
		{
			title: $t({ id: 'statistics1' }),
			suffix: 'T',
			endCount: 51667,
		},
		{
			title: $t({ id: 'statistics2' }),
			prefix: '$',
			suffix: 'M',
			endCount: 42.4,
			decimals: 1,
		},
		{
			title: $t({ id: 'statistics3' }),
			// prefix: '#',
			endCount: 861,
		},
	];

	useEffect(() => {
		// fire up counting : after one second
		const all = document.getElementsByClassName('title_count_up');
		setTimeout(() => {
			for (let i = 0; i < all.length; i++) {
				all[i].click();
			}
		}, 1000);
	}, []);

	return (
		<Grid
			display={'grid'}
			gap={'40px'}
			px={{ xs: '10px', xxs: '32px', md: '103px' }}
		>
			<Typography
				variant={'h2'}
				display={'flex'}
				justifyContent={'center'}
				fontSize={'25px'}
			>
				{$t({ id: 'statisticsTitleMainPage' })}
			</Typography>
			<Grid
				display={'flex'}
				flexWrap={'wrap'}
				alignItems={'center'}
				justifyContent={'center'}
				gap={'24px'}
			>
				{statisticsData.map(({ title, prefix, endCount, suffix, decimals }, index) => (
					<FeatureItem
						key={index}
						{...{ title, prefix, endCount, suffix, decimals }}
					/>
				))}
			</Grid>
		</Grid>
	);
};

const FeatureItem = ({ endCount, title, prefix = '', suffix = '', decimals = 0 }) => {
	return (
		<CountUp
			end={endCount}
			duration={3}
			delay={2}
			prefix={prefix}
			suffix={suffix}
			decimals={decimals}
		>
			{({ countUpRef, start }) => (
				<Grid
					display={'grid'}
					justifyContent={'center'}
					justifyItems={'center'}
					gap={'6px'}
					width={'220px'}
					border={`2px solid rgba(255, 191, 63)`}
					padding={'12px'}
					boxShadow={'2px 4px 15px 0px #00000026'}
					bgcolor={'#FFEFD0'}
					borderRadius={'6px'}
				>
					<Grid
						display={'flex'}
						gap={'4px'}
						fontSize={'36px'}
						fontWeight={700}
					>
						<span ref={countUpRef} />
					</Grid>
					<Typography
						className={'title_count_up'}
						onClick={start}
						variant="span"
						fontSize={'18px'}
					>
						{title}
					</Typography>
				</Grid>
			)}
		</CountUp>
	);
};

export default Statistics;
